/** @jsx isolateComponent */

import { Text, Button } from '@zapier/design-system';
import {
  isolateComponent,
  labelStyles,
  withModifier,
} from '@zapier/common-utils';
import { useStaticAssetPath } from '@zapier/common-components';
import { Interpolation } from '@emotion/css';

const tabletMediaQuery = `@media screen and (min-width: 1000px)`;

const Styles = labelStyles(__filename, {
  root: (isCondensed: boolean) => [
    {
      height: '252px',
      margin: '50px 0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      paddingLeft: '120px',
      [tabletMediaQuery]: {
        paddingLeft: '100px',
      },
    },
    isCondensed &&
      withModifier('isCondensed', {
        paddingLeft: 0,
        height: '200px',
        textAlign: 'center',
      }),
  ],
  image: (promoImgUrl: string) => ({
    backgroundImage: `url("${promoImgUrl}")`,
    backgroundPosition: 'left',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '147px 498px',
    position: 'absolute',
    height: '499px',
    width: '147px',
    left: '25px',
    top: '-1px',
  }),
  text: { zIndex: 1 },
});

type CompaniesIntroPromoProps = {
  /** Is this condensed from a narrow screen? */
  isCondensed: boolean;
};

const CompaniesIntroPromo = (props: CompaniesIntroPromoProps) => {
  const { buildStaticAssetUrl } = useStaticAssetPath();
  const promoImgUrl = buildStaticAssetUrl('/images/login/companies-login.png');
  return (
    <div css={Styles.root(props.isCondensed) as Interpolation}>
      {!props.isCondensed && (
        <div css={Styles.image(promoImgUrl) as Interpolation} />
      )}
      <div css={Styles.text}>
        <Text color="grey900" tag="h1" type="header800">
          Zapier for Companies
        </Text>
      </div>
      <div css={Styles.text}>
        <Text color="grey900" type="subtitle700">
          Scale automations with SAML Single Sign On, App access control,
          unlimited Zaps and much more
        </Text>
      </div>
      <Button hasShadow={true} href="/companies" size="small">
        Try Our New Company Plan
      </Button>
    </div>
  );
};

export default CompaniesIntroPromo;
